import { customerMardomGo } from './customerMardomGo'

export class customerMardomGoListHeader
{
    total: number
    start: number
    limit: number
    length: number
    users:customerMardomGo[]
}